// eslint-disable-next-line
Array.prototype.getMetaProperty = function (pointer, attribute) {
    if (!this) return null;
    for (let i = 0; i < this.length; i++) {
        if (this[i].pointer === pointer && this[i].attributes === attribute) {
            return true;
        }
    }
    return false;
};
export function getMetaProperty(array, pointer, attribute) {
    if(!array) return null;
    return array.getMetaProperty(pointer, attribute);
}